export class AppCheckbox extends HTMLElement {
  static get observedAttributes() {
    return ["label", "checked", "disabled", "required", "name", "value"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  get checked(): boolean {
    const input = this.querySelector("input");
    return input ? input.checked : false;
  }

  set checked(val: boolean) {
    const input = this.querySelector("input");
    if (input) {
      input.checked = val;
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const checked = this.hasAttribute("checked");
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const name = this.getAttribute("name") || "";
    const value = this.getAttribute("value") || "on";

    const id = `chk-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <label for="${id}" style="display: inline-flex; align-items: center; gap: 8px; font-size: 0.875rem; cursor: ${disabled ? "not-allowed" : "pointer"}; user-select: none;">
        <input
          id="${id}"
          type="checkbox"
          name="${name}"
          value="${value}"
          ${checked ? "checked" : ""}
          ${disabled ? "disabled" : ""}
          ${required ? "required" : ""}
          style="accent-color: var(--color-primary); width: 16px; height: 16px;"
        />
        <span>${label}</span>
      </label>
    `;
  }
}

if (!customElements.get("app-checkbox")) {
  if (!customElements.get("app-checkbox")) {
    customElements.define("app-checkbox", AppCheckbox);
  }
}

export class AppCheckboxGroup extends HTMLElement {
  connectedCallback() {
    this.style.display = "flex";
    this.style.flexDirection = "column";
    this.style.gap = "8px";
  }
}

if (!customElements.get("app-checkbox-group")) {
  if (!customElements.get("app-checkbox-group")) {
    customElements.define("app-checkbox-group", AppCheckboxGroup);
  }
}
